import { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { IconArrowLeft } from '@tabler/icons';
import { Container, Button } from './styles';

interface ModalProps {
  onClose: () => void;
  isOpen: boolean;
  [x: string]: any;
}

export default function Modal({ children, isOpen, onClose }: ModalProps) {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const history = useHistory();

  const overlayRef = useRef<any>();

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
    }

    if (!isOpen && overlayRef.current) {
      overlayRef.current.addEventListener('animationend', () => {
        setShouldRender(false);
      });
    }
  }, [isOpen]);

  // hide scrollbar when is open
  useEffect(() => {
    const body = document.querySelector('body');

    if (body) {
      if (isOpen) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'auto';
      }
    }
  }, [isOpen]);

  // prevent navigating back when back button is pressed
  useEffect(() => {
    const unblock = history.block((location, action): any => {
      if (action === 'POP' && isOpen) {
        onClose();

        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [isOpen, history]);

  if (!shouldRender) {
    return null;
  }

  return (
    <Container isOpen={isOpen} ref={overlayRef}>
      <Button onClick={onClose}>
        <IconArrowLeft size={24} />
      </Button>

      {children}
    </Container>
  );
}
